import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import common from './modules/common';
import pageManament from './modules/pageManament';

Vue.use(Vuex);

const store = new Vuex.Store({
  // 构建工具根据环境开启严格模式
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    user,
    common,
    pageManament
  }
});

export default store;
